/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import DataTypes from './data-types'

/**
 * Filter constructor
 * @method mixin   - flattens `filterModel`
 * @method request - returns request filter parameters
 *
 */
export const Filter = {
  /**
   * @param   {Object} model  - `filterModel`
   * @param   {String} search - quick filter text
   * @returns {Object} filter - flattened (key, val) filter
   */
  mixin(model, search, screen) {
    const filter = {}

    Object.keys(model).forEach((key) => {
      filter[key] = model[key].filter
    })

    filter.searchTerm = search
    filter.screen = screen
    return filter
  },

  /**
   * @param   {Object} params - grid state `params`
   * @returns {Object} params - request parameters
   */
  request(params) {
    return {
      // sort                  : 'CreatedDateStr',
      dir                   : 'DESC',
      start                 : params.startRow,
      limit                 : 100,
      isLiveGrid            : true,
      getJustVisibleColumns : true,
      filter                : JSON.stringify(
        Filter.mixin(
          params.filterModel,
          params.search,
          params.screen
        )
      )
    }
  }
}

/**
 * Column model constructor
 * @method mixin  - maps model to `columnDefs`
 * @method header - mixins filters into column model
 *
 */
export const Model = {
  /**
   * @param   {Object} model      - backend column model
   * @returns {Array} columnModel - mapped model
   */
  mixin(model) {
    const columnModel = []

    Object.keys(model).forEach(key => {
      const label = model[key].label || model[key]

      columnModel.push(
        {
          headerName   : label,
          field        : key,
          hide         : typeof model[key].visible !== 'undefined' && !model[key].visible,
          cellRenderer : ~label.indexOf('Date') ? DataTypes.date.column : null,
          // filter       : ~label.indexOf('Date') ? 'date' : null,
          // editable     : label.indexOf('Name') > -1,
          // filterFramework : ~label.indexOf('Status') ? DataTypes.date.filter : null,
          filterFramework: DataTypes.text.filter,

          filterParams : {
            applyButton   : true,
            clearButton   : true,
            newRowsAction : 'keep'
          }
        }
      )
    })

    return columnModel
  },

  /**
   * @param   {Object} model      - backend column model
   * @param   {Object} params     - grid state `params`
   * @returns {Array} columnModel - mapped model
   */
  header(model, params) {
    const columns = []

    Object.keys(model).forEach(key => {
      columns.push(
        {
          data: key,
          name: '',
          searchable: true,
          orderable: true,
          search: {
            value: params.filterModel[key] && params.filterModel[key].filter || '',
            regex: false
          }
        }
      )
    })

    return {
      draw    : 1,
      columns : columns,
      start   : params.startRow,
      length  : 100,
      search  : {
        value : params.search,
        regex : false
      }
    }
  }
}

/**
 * Remote datasource
 * @method fetch - binds `getRows` to api request
 *
 */
export const Data = {
  /**
   * @param   {Object} grid               - vue instance
   * @returns {Object} `datasource` model - grid datasource settings
   */
  fetch(grid) {
    return {
      rowCount: null,
      getRows(params) {
        const legacy = grid.$parent.$vnode.data.class ? grid.$parent.$vnode.data.class.indexOf('legacy') > -1 : grid.legacy
        var payload = null

        params.search = grid.searchTerm
        params.screen = grid.screen

        if (legacy) {
          payload = Filter.request.call(grid, params)
        } else {
          payload = Model.header(grid.$parent.model, params)
        }

        grid.api.forms.post(grid.endpoint, payload)
          .then(response => {
            if (response && response.data && typeof response.data === 'object') {
              params.successCallback(
                response.data.data || response.data.Data,
                response.data.recordsFiltered || response.data.Count
              )

              grid.ps.update()
            } else {
              // Notification message
              // (probably session expired)
              if (typeof response.data === 'string') {
                if (response.data.indexOf('session has expired')) {
                  grid.$store.commit('updateSessionValidity', null)
                }
              }
            }
          })
          .catch(error => {
            console.warn(error)

            // Notification message
            global.app.$notifications.notify({
              type      : 'warning',
              icon      : 'notifications',
              message   : error.message,
              placement : { from: 'bottom', align: 'right' }
            })
          })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/adapters.js